// extracted by mini-css-extract-plugin
export default {"grow":"TabButton_grow__5DxFa","label":"TabButton_label__mD1VS","tab":"TabButton_tab__wrfeU","tabActive":"TabButton_tabActive__KHvTF"};